import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import Slider from "react-slick"
import FlatCard from 'components/molecules/FlatCard'
import ReactHtmlParser from 'react-html-parser'
import { get } from 'lodash'

import 'slick-carousel/slick/slick.css'
import './FlatCards.scss'

function FlatCards(props) {
  const items = get(props, 'items')
  const title = get(props, 'title')
  const description = get(props, 'description')
  const setting = {
    dots: true,
    dotsClass: `slick-dots ${props.color ? props.color : "primary"}`,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1.3,
        },
      },
    ],
  }

  return (
    <Container className="flat-cards bg-gray-400" fluid="fluid">
      <Container className="pb-5 pt-5">
        <Row>
          <Col>
            <ContentBlock>
              <Typography variant="h5" color="primary" cssClass="title-bold-md">
                {title}
              </Typography>
              <div className="description-text mt-2">
                {ReactHtmlParser(description)}
              </div>
            </ContentBlock>
          </Col>
        </Row>
        <section className="mt-3">
          {Array.isArray(items) &&
            <Slider {...setting} className="flat-cards-carousel">
              {Array.isArray(items) && items.map(function (item) {
                const titleItem = get(item, 'entity.title')
                const descriptionItem = get(item, 'entity.description.value')
                const uuid = get(item, 'entity.uuid')
                return (
                  <FlatCard
                    key={uuid}
                    color="primary"
                    title={titleItem ? titleItem.toUpperCase() : ''}
                    description={descriptionItem}
                  />
                )
              })}
            </Slider>
          }

        </section>
      </Container>
    </Container>
  );
}

export default FlatCards;
